import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=028b20f6&scoped=true&"
import script from "./integrations.ts?vue&type=script&lang=ts&"
export * from "./integrations.ts?vue&type=script&lang=ts&"
import style0 from "./integrations.scss?vue&type=style&index=0&id=028b20f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028b20f6",
  null
  
)

export default component.exports